<template>
  <div class="rankingTopThreeCell__container">
    <div
      class="rankingTopThreeCell__iconContainer"
      :style="this.isFirst ? 'padding-top: 10px;' : 'padding-top: 30px;'"
    >
      <div
        class="rankingTopThreeCell__iconRankImg"
        v-bind:class="{ 'rankingTopThreeCell__iconRankImg--isFirst': isFirst }"
        :style="{
          'background-image':
            'url(' + this.$resources.iconBackgroundImage(result.rank) + ')',
        }"
      >
        <img
          :src="getIconUrl(result.icon_url, 78)"
          class="rankingTopThreeCell__iconImg"
        />
        <img
          :src="this.$resources.iconBadgeImage(result.rank)"
          class="rankingTopThreeCell__iconBadgeImg"
        />
      </div>
    </div>
    <p class="rankingTopThreeCell__containerName">
      {{ result.name !== undefined ? result.name : '-' }}
    </p>
    <p class="rankingTopThreeCell__containerScore">
      {{ result.score !== undefined ? commaSepalatedValue : '-' }}
    </p>
  </div>
</template>

<script>
import formatter from '@/utils/Formatter'
import ImgUrl from '@/utils/ImgUrl'
export default {
  name: 'RankingTopThreeCell',
  props: {
    result: {
      rank: Number,
      icon_url: String,
      name: String,
      score: Number,
    },
    isFirst: Boolean,
  },
  computed: {
    commaSepalatedValue() {
      return formatter.vliveFormat(this.result.score)
    },
  },
  methods: {
    getIconUrl: function (baseUrl, size) {
      return ImgUrl.getIconUrlWithSize(baseUrl, size)
    },
  },
}
</script>

<style scoped>
.rankingTopThreeCell__container {
  display: flex;
  flex-direction: column;
}

.rankingCell__container p {
  display: flex;
  flex-direction: column;
}

.rankingTopThreeCell__iconContainer {
  flex-grow: 1;
  display: flex;
  align-items: flex-end;
  position: relative;
  padding-top: 10px;
}

.rankingTopThreeCell__iconRankImg {
  width: 83px;
  height: 83px;
  background-size: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 8px 6px;
  position: relative;
}

.rankingTopThreeCell__iconRankImg--isFirst {
  width: 103px;
  height: 103px;
}

.rankingTopThreeCell__iconRankImg--isFirst .rankingTopThreeCell__iconImg {
  width: 78px;
  height: 78px;
  background-color: #e8e8e8;
}

.rankingTopThreeCell__iconImg {
  width: 61px;
  height: 61px;
  border-radius: 50%;
  background-color: #e8e8e8;
}

.rankingTopThreeCell__iconBadgeImg {
  width: 28px;
  height: 28px;
  position: absolute;
  right: 6px;
  bottom: 3px;
}

.rankingTopThreeCell__container p {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
}

.rankingTopThreeCell__containerName {
  margin: 0 auto 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80px;
}

.rankingTopThreeCell__containerScore {
  color: #188dff;
  margin-bottom: 20px;
}
</style>
